import FindTemplate from "../../components/find/FindTemplate";
import FindPostListContainer from "../../containers/find/FindPost/FindPostListContainer";

const findPage = () => {
  //

  return (
    <>
      <FindTemplate />
      <FindPostListContainer />
    </>

  );
};

export default findPage;